var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGentaldrying = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 122 122"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M61 92.5c-17.37 0-31.5-14.13-31.5-31.5S43.63 29.5 61 29.5 92.5 43.63 92.5 61 78.37 92.5 61 92.5m0-60c-15.71 0-28.5 12.79-28.5 28.5S45.29 89.5 61 89.5 89.5 76.71 89.5 61 76.71 32.5 61 32.5",
  className: "gentaldrying_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98 98H24V24h74zm-71-3h68V27H27z",
  className: "gentaldrying_svg__cls-1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 61,
  r: 6.5,
  className: "gentaldrying_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122 122H0V0h122zM2 120h118V2H2z",
  className: "gentaldrying_svg__cls-1"
}))));
export default SvgGentaldrying;